// extracted by mini-css-extract-plugin
export default {"container":"GlobalNotification_container__i9R3p","goToOldVersion":"GlobalNotification_goToOldVersion__Ud5hc"};